import { selectAccountAttributeElement } from 'affiny-core/redux/selectors/accountSelectors';
import { AffinyEndpoint } from '../affinyEndpoints/affiny.endpoints';

export const ReflistResource = {
  getReflist: (kvk: ReturnType<typeof selectAccountAttributeElement>) =>
    AffinyEndpoint.Reflist.url(`/${kvk}/`).get().json(),
};
